import { Link } from "react-router-dom";
import { HardHat, PhoneCall } from "lucide-react";

export default function Troubleshooting() {
  return (
    <main className="bg-white">
      <section className="border-b border-zinc-200 bg-[#FDFDFD]">
        <div className="container mx-auto px-6 py-20">
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500 mb-6">Knowledge Base</div>
          <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tighter">Troubleshooting Guide.</h1>
          <p className="mt-6 text-lg text-zinc-700 max-w-2xl">Practical guides to help you understand common caravan issues.</p>
        </div>
      </section>

      <section className="bg-white">
        <div className="container mx-auto px-6 py-24">
          <div
            data-testid="troubleshooting-under-construction"
            className="max-w-2xl mx-auto border border-amber-300 bg-amber-50 p-10 text-center flex flex-col items-center gap-5"
          >
            <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center">
              <HardHat className="w-7 h-7 text-amber-600" />
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-amber-700">Under Construction</div>
            <h2 className="font-display font-black text-2xl sm:text-3xl text-zinc-950 tracking-tight">
              This section is being worked on.
            </h2>
            <p className="text-zinc-700 leading-relaxed max-w-md">
              Our troubleshooting guides are temporarily offline while we update them. They'll be back soon. In the meantime, if something's not right with your van, leave us a request and a technician will take a look and get back to you.
            </p>
            <Link
              to="/request"
              data-testid="troubleshooting-request-btn"
              className="mt-2 inline-flex items-center gap-2 bg-[#16A34A] text-white px-6 py-3 font-semibold hover:bg-[#15803D] transition-colors"
            >
              <PhoneCall className="w-4 h-4" /> Request a Service or Call Back
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
